import { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import useStyles from "./style";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { profiledetails } from "../../Redux/ProfileSettings/actions";
import { showLoader, hideLoader } from "../../Redux/Loader/actions";
import _ from "lodash";
import settingsApi from "Services/Settings";

// MUI Icons
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import DirectionsBusRoundedIcon from "@mui/icons-material/DirectionsBusRounded";
import EventNoteRoundedIcon from "@mui/icons-material/EventNoteRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { Wallet } from "@mui/icons-material";
import { Button } from "@mui/material";

// ─── Sidebar nav items ────────────────────────────────────────────────────────
const NAV_ITEMS = [
  { label: "Dashboard",       icon: <img src="/assets/images/sidebar_icons/Dashboard.png" alt="Dashboard" width="22" height="22" />,               path: "/dashboard_hotel" },
  { label: "Wallet",          icon: <img src="/assets/images/sidebar_icons/User Wallet.png" alt="Wallet" width="22" height="22" />,     path: "/hotel-wallet" },
  { label: "My Trips",        icon: <img src="/assets/images/sidebar_icons_2.0/LIst location.png" alt="My Trips" width="22" height="22" />,      path: "/hoteltriplist" },
  // { label: "Upcoming Trips",  icon: <EventNoteRoundedIcon />,                path: "/upcomingtrips_hotel" },
  { label: "Profile",         icon: <img src="/assets/images/sidebar_icons/Members.png" alt="Profile" width="22" height="22" />,          path: "/profilesettings_hotel" },
  { label: "Change password", icon: <img src="/assets/images/sidebar_icons/Change Password.png" alt="Profile" width="22" height="22" />,         path: "/hotelchange-password" },
  { label: "Logout", icon: <img src="/assets/images/sidebar_icons/Sign Out.png" alt="Logout" width="22" height="22" />, path: null },
];

// ─── Styles ───────────────────────────────────────────────────────────────────
const SIDEBAR_EXPANDED = 220;
const SIDEBAR_COLLAPSED = 64;

const sidebarStyle = (expanded) => ({
  width: expanded ? SIDEBAR_EXPANDED : SIDEBAR_COLLAPSED,
  minWidth: expanded ? SIDEBAR_EXPANDED : SIDEBAR_COLLAPSED,
  height: "100%",
  backgroundColor: "#ffffff",
  borderRight: "1px solid #f0f0f0",
  transition: "width 0.25s ease, min-width 0.25s ease",
  overflowX: "hidden",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  paddingTop: "12px",
  boxShadow: "2px 0 8px rgba(0,0,0,0.04)",
  zIndex: 100,
  flexShrink: 0,
});

const navItemStyle = (active, expanded) => ({
  display: "flex",
  alignItems: "center",
  gap: expanded ? "12px" : "0px",
  justifyContent: expanded ? "flex-start" : "center",
  padding: expanded ? "10px 20px" : "10px 0",
  margin: "2px 8px",
  borderRadius: "10px",
  cursor: "pointer",
  backgroundColor: active ? "#f3f0ff" : "transparent",
  color: active ? "#09080a" : "#555",
  fontWeight: active ? 700 : 500,
  fontSize: "14px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  transition: "background-color 0.15s ease, color 0.15s ease",
  userSelect: "none",
  textDecoration: "none",
});

// const logoutItemStyle = (expanded) => ({
//   display: "flex",
//   alignItems: "center",
//   gap: expanded ? "12px" : "0px",
//   justifyContent: expanded ? "flex-start" : "center",
//   padding: expanded ? "10px 20px" : "10px 0",
//   margin: "2px 8px",
//   borderRadius: "10px",
//   cursor: "pointer",
//   color: "#ef4444",
//   fontWeight: 500,
//   fontSize: "14px",
//   whiteSpace: "nowrap",
//   overflow: "hidden",
//   transition: "background-color 0.15s ease",
//   userSelect: "none",
// });

// ─── Component ────────────────────────────────────────────────────────────────
const HotelLayout = ({ children }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [profileDetails, setProfileDetails] = useState([]);

  // get site logo
  const siteNewL = useSelector(
    (state) => state?.SiteSettingsReducer?.siteNewLogo
  );

  // Get Admin profile details
  const getAdminProfileDetails = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setProfileDetails(res?.data?.data);
        dispatch(profiledetails(res?.data?.data.image));
      } else {
        setProfileDetails([]);
      }
    };
    const onFailure = (err) => {};
    settingsApi.getProfileDetails({}).then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getAdminProfileDetails();
  }, [getAdminProfileDetails]);

  // handle logout
  const handleLogout = () => {
    dispatch(showLoader("Logging out..."));
    localStorage.clear();
    navigate(0);
    dispatch(hideLoader());
  };

  const handleNavClick = (path) => {
    navigate(path);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* ── Header ── */}
      <nav
        className="sticky-top navbar navbar-light bg-white d-flex justify-content-between align-items-center px-4"
        style={{
          height: "70px",
          boxShadow: "0 2px 15px rgba(0,0,0,0.05)",
          zIndex: 1000,
          flexShrink: 0,
        }}
      >
        {/* Hamburger — toggles sidebar expand/collapse */}
        <button
          className="btn"
          style={{
            border: "1.5px solid #e0e0e0",
            borderRadius: "8px",
            padding: "6px 10px",
            background: "#fff",
            fontSize: "18px",
            lineHeight: 1,
            cursor: "pointer",
          }}
          onClick={() => setSidebarExpanded((prev) => !prev)}
        >
          ☰
        </button>

        {/* Center Logo */}
        <div className="navbar-brand mx-auto d-flex justify-content-center align-items-center">
          <img
            src="/assets/images/logos/hotellogo.png"
            alt="Logo"
            style={{
              maxWidth: "160px",
              width: "100%",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </div>

        {/* Wallet + Profile */}
        <div className="d-flex align-items-center gap-3">
          <div className="d-none d-md-flex align-items-center gap-3">
            <Button
              variant="outlined"
              color="inherit"
              startIcon={<img src="/assets/images/sidebar_icons/User Wallet.png" alt="Wallet" width="22" height="22" /> }
              onClick={() => navigate("/hotel-wallet")}
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                borderColor: "#ccc",
                color: "#000",
                padding: "4px 16px",
              }}
            >
              Wallet
            </Button>

            <Dropdown align="end">
              <Dropdown.Toggle
                variant="light"
                id="dropdown-basic"
                className="d-flex align-items-center gap-2"
              >
                <img
                  src={
                    !_.isEmpty(profileDetails?.image)
                      ? `${profileDetails?.image}`
                      : "/assets/images/user/avatar.png"
                  }
                  alt="User Avatar"
                  height="42"
                  width="42"
                  className="rounded-circle"
                  style={{ objectFit: "cover" }}
                />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => navigate("/profilesettings_hotel")}
                >
                  Profile
                </Dropdown.Item>
                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </nav>

      {/* ── Body: Sidebar + Main ── */}
      <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
        {/* ── Sidebar ── */}
        <aside style={sidebarStyle(sidebarExpanded)}>
          <nav style={{ flex: 1 }}>
           {NAV_ITEMS.map((item) => {
  const active = isActive(item.path);
  return (
    <div
      key={item.label}  // ← changed from item.path (null would break key)
      style={navItemStyle(active, sidebarExpanded)}
      onClick={() => item.path === null ? handleLogout() : handleNavClick(item.path)}  // ← only this line changed
      title={!sidebarExpanded ? item.label : undefined}
      onMouseEnter={(e) => {
        if (!active) {
          e.currentTarget.style.backgroundColor = "#f5f5f5";
        }
      }}
      onMouseLeave={(e) => {
        if (!active) {
          e.currentTarget.style.backgroundColor = "transparent";
        }
      }}
    >
      {/* Icon */}
      <span
        style={{
          display: "flex",
          alignItems: "center",
          flexShrink: 0,
          color: active ? "#6c47ff" : "#888",
          fontSize: "20px",
        }}
      >
        {item.icon}
      </span>

      {/* Label — only visible when expanded */}
      {sidebarExpanded && (
        <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
          {item.label}
        </span>
      )}
    </div>
  );
})}
          </nav>

          {/* Logout at bottom */}
          {/* <div style={{ paddingBottom: "16px" }}>
            <div
              style={logoutItemStyle(sidebarExpanded)}
              onClick={handleLogout}
              title={!sidebarExpanded ? "Logout" : undefined}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#fff0f0")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexShrink: 0,
                  fontSize: "20px",
                  color: "#ef4444",
                }}
              >
                <LogoutRoundedIcon />
              </span>
              {sidebarExpanded && <span>Logout</span>}
            </div>
          </div> */}
        </aside>

        {/* ── Page Content ── */}
        <main className="d-flex flex-column flex-grow-1 p-3 bg-light" style={{ overflowY: "auto" }}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default HotelLayout;

